/**
 * Created by andrey on 24.05.17.
 */

cleverapps.Tool = cleverapps.override(cleverapps.Tool, {
    UI: {
        windows: {
            canUpgradeHeroWindow: displayToolWindow(() => {
                new CanUpgradeHeroWindow();
            }),

            boosterUnlockedWindow: ToolFolder.create(() => {
                const res = {};

                cleverapps.boosters.listBoosters().forEach((booster) => {
                    const level = booster.available && booster.available.actualLevel;
                    const name = `${booster.type || booster.id}${level ? `_lvl${level}` : ""}`;

                    res[name] = displayToolWindow(() => {
                        new BoosterUnlockedWindow(booster);
                    });
                });

                return res;
            })
        },

        helpByFiveAttemptsWindow: displayToolWindow(() => {
            new HelpByFiveAttemptsWindow();
        })
    },

    game: {
        win: function () {
            if (Game.currentGame && cleverapps.Scenes.GetSceneComponent(GameSceneComponent)) {
                if (Game.currentGame.tutorial && !Game.currentGame.tutorial.finished) {
                    Game.currentGame.tutorial.finishAll();
                }

                const goals = Game.currentGame.goals;

                for (const type in goals.elements) {
                    goals.incGoal(type, goals.elements[type].target - goals.elements[type].amount);
                }

                Game.currentGame.counter.setTimeout(() => {}, 100);
                Game.currentGame.goalCounter.runStages();
            }
        },

        movesReset: function () {
            if (Game.currentGame) {
                Game.currentGame.setMoves(1, { silent: true });
            }
        },

        goalsOneMore: function () {
            if (Game.currentGame) {
                const goals = Object.values(Game.currentGame.goals.elements);

                goals.forEach((goal, index) => {
                    const isLast = index === goals.length - 1;
                    let dt = Math.max(0, goal.target - goal.amount);
                    if (isLast) {
                        dt--;
                    }
                    dt && goal.inc(dt);
                });
                Game.currentGame.goalCounter.runStages();
            }
        },

        addBoosterCell: function () {
            if (Game.currentGame) {
                Game.currentGame.field.pushNextCell(BoosterCell);
            }
        },

        addMovesWindow: function () {
            Game.currentGame.trigger("outOfMoves");
        },

        exclamations: ToolFolder.create(() => {
            const res = {};
            if (cleverapps.environment.isGameScene()) {
                res.shuffle = function () {
                    cleverapps.exclamation.show("message.Shuffle");
                };
                res.goals_done = function () {
                    cleverapps.exclamation.show("message.YouWin", Exclamation.Types.Congrats);
                };
                res.five_moves = function () {
                    cleverapps.exclamation.show("message.MovesLeft", Exclamation.Types.Warning);
                };
                res.hardlevel = function () {
                    cleverapps.exclamation.show("message.hardLevel", Exclamation.Types.Warning);
                };
                res.lets_go = function () {
                    cleverapps.exclamation.show("message.Letsgo");
                };
                res.tutorial_finish = function () {
                    cleverapps.exclamation.show("message.KeepGoing");
                };
                res.congratulation = function () {
                    const msg = PseudoRandom.GET().mathChoose(cleverapps.exclamation.getCongratulations());
                    cleverapps.exclamation.show(msg, Exclamation.Types.Congrats);
                };
            }
            return res;
        }),

        showUp: function () {
            const field = Game.currentGame.field;
            const fieldView = field.onGetView();
            const floorView = fieldView.floorView;

            fieldView.innerContainer.children.forEach((cellView) => {
                cellView.setScaleY(0);
            });
            fieldView.hideGoals();

            if (cleverapps.config.name !== "riddles") {
                floorView.setVisible(false);
            } else {
                fieldView.setVisible(true);
                floorView.setVisible(true);

                fieldView.onResize();
            }

            field.showUpAnimation(false, () => {});
        },

        hide: function () {
            Game.currentGame.field.trigger("hide", () => {
                Game.currentGame.field.onGetView().setScale(1);
            });
        }
    }
});